import { Col, Row } from 'react-bootstrap';

import { DOICited } from './citations/DOICited';
import { DOIExternalReferences } from './DOIExternalReferences';
import { DOIRelated } from './DOIRelated';
import { DOITypes } from './DOITypes';
import { DOIInstrumentMetadata } from './metadata/DOIInstrumentMetadata';
import { DOIParticipants } from './participants/DOIParticipants';
import { DOIReference } from './reference/DOIReference';
import { type DOI } from './utils/doi';

export function DOIInfoInstrument({ doi }: { doi: DOI }) {
  return (
    <>
      <Row className="mb-2">
        <DOITypes doi={doi} />
      </Row>
      <Row className="g-2">
        <Col xs={12} lg={7} xl={8} xxl={9}>
          <Row className="g-2">
            <Col xs={12}>
              <h3 style={{ marginTop: '-0.25rem' }}>{doi.title}</h3>
            </Col>
            <Col xs={12}>
              <DOIParticipants doi={doi} />
            </Col>
            <Col xs={12}>
              <pre
                className="m-0"
                style={{
                  textAlign: 'justify',
                  whiteSpace: 'pre-wrap',
                  wordWrap: 'break-word',
                  fontFamily: 'inherit',
                  overflowWrap: 'break-word',
                  overflowX: 'hidden',
                }}
              >
                {doi.description}
              </pre>
            </Col>
            <Col xs={12}>
              <DOIExternalReferences doi={doi} />
            </Col>
            <Col xs={12}>
              <DOIReference doi={doi}>
                If you wish to cite this beamline in a research publication,
                please refer to the{' '}
                <a
                  href="https://www.esrf.fr/UsersAndScience/UserGuide/Publications"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ESRF publication guidelines
                </a>
                .
              </DOIReference>
            </Col>
            <Col xs={12}>
              <DOICited doi={doi} />
            </Col>
          </Row>
        </Col>
        <Col xs={12} lg={5} xl={4} xxl={3}>
          <Row className="g-2">
            <Col xs={12}>
              <DOIInstrumentMetadata doi={doi} />
            </Col>
            <Col xs={12}>
              <DOIRelated doi={doi} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
